import { render, staticRenderFns } from "./EVAlert.vue?vue&type=template&id=64f76a70&scoped=true"
import script from "./EVAlert.vue?vue&type=script&lang=js"
export * from "./EVAlert.vue?vue&type=script&lang=js"
import style0 from "./EVAlert.vue?vue&type=style&index=0&id=64f76a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f76a70",
  null
  
)

export default component.exports